import React from 'react';

const RadioButton = ({ color = 'black', className, onClick, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18.8333C14.6023 18.8333 18.3333 15.1023 18.3333 10.5C18.3333 5.89762 14.6023 2.16667 10 2.16667C5.39762 2.16667 1.66667 5.89762 1.66667 10.5C1.66667 15.1023 5.39762 18.8333 10 18.8333ZM10 20.5C15.5229 20.5 20 16.0229 20 10.5C20 4.97716 15.5229 0.5 10 0.5C4.47716 0.5 0 4.97716 0 10.5C0 16.0229 4.47716 20.5 10 20.5Z"
        fill={color}
      />
      <path
        d="M9.9974 16.3337C13.2191 16.3337 15.8307 13.722 15.8307 10.5003C15.8307 7.27866 13.2191 4.66699 9.9974 4.66699C6.77573 4.66699 4.16406 7.27866 4.16406 10.5003C4.16406 13.722 6.77573 16.3337 9.9974 16.3337Z"
        fill={color}
      />
    </svg>
  );
};

export default RadioButton;
